import { Component,Input, OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PersonalService } from '../../services/personal.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { ImagenService } from '../../services/imagen.service';
import { ErroresService } from '../../core/services/errores.service';
import { MomentSetService} from '../../core/services/moment-set.service';

interface City {
  name: string,
  code: string
}

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})

export class PersonalComponent implements OnInit  {

  @Input() imagen;

  profileImage:any;
  selectedFile : File = null;
  edad: number;
  id: number;
  personal:any;
  personalLegajo: string;
  selectedEmp:any;
  SelectedId:any;
  showDetails:boolean = false;
  myControl = new FormControl();
  personalRelacion: any;
  selectedPersonal: string;
  permisoBorrado: boolean = false;
  MensajeError: string;
  Invalido: boolean;
    
  public constructor(private personalService: PersonalService,
                     private route: ActivatedRoute,
                     private sanitizer: DomSanitizer,
                     private router: Router,
                     private dialog: MatDialog,
                     private imagenSrv: ImagenService,
                     private actRoute: ActivatedRoute,
                     private erroresService: ErroresService,
                     private momentService: MomentSetService) {

    this.personalLegajo = this.actRoute.snapshot.params.legajo;
  }
  
  public ngOnInit():any {
    this.profileImage = './assets/images/sinFoto.png';

    this.route.params.subscribe(params => {
      this.personalLegajo = params['legajo'];
      this.retrievePersonal();
    });
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Borrar Datos Personales")) this.permisoBorrado = true;
  }

  retrievePersonal(): void 
  {
    this.personalService.getAll().subscribe(
      data => 
      {
        this.personal = data;
        console.log(data);
        if (this.personalLegajo != undefined){
          this.paramPersonal();
        }
      },
      error => {
        console.log(error);
      });
  }

  onChangePersonal(event) 
  {
    console.log('event :' + event);
    
    this.MensajeError = "";
    this.Invalido = false;
    this.showDetails = false;
    this.profileImage = './assets/images/sinFoto.png';
    
    if (event.value != null)
    {
      this.selectedEmp = event.value.code;
      let selectPer = this.personal.find(d => d.code == this.selectedEmp);
      this.SelectedId = selectPer.id;
    
      this.cargarPersonal();
    }
  } 

  cargarPersonal()
  {
    this.personalService.getDetail(this.selectedEmp).subscribe(
      data => 
    {
      data.fechaNacimiento = this.momentService.convertDateServer(data.fechaNacimiento);
      data.liquidarDesde = this.momentService.convertDateServer(data.liquidarDesde);
      data.liquidarHasta = this.momentService.convertDateServer(data.liquidarHasta);
      data.retroactividad = this.momentService.convertDateServer(data.retroactividad);
      data.ultimaLiquidacion = this.momentService.convertDateServer(data.ultimaLiquidacion);
      
      this.personalRelacion = data;
      this.edad = moment().diff(data.fechaNacimiento, 'years');
      this.loadImage();
      this.showDetails = true;
      console.log(data);
    },
    error => {          
      console.log(error);
    });
  }

  paramPersonal() 
  {
    console.log('param :' + this.personalLegajo);
    this.selectedEmp = this.personalLegajo;
    let selectPer = this.personal.find(d => d.code == this.selectedEmp);
    this.SelectedId = selectPer.id;
    this.selectedPersonal = selectPer;
    this.showDetails = false;
    this.profileImage = './assets/images/sinFoto.png';
    
    this.cargarPersonal();
  } 

  loadImage(){
    this.imagenSrv.getDetail(this.SelectedId).subscribe(data => {
      this.imagen = data;
      if (this.imagen === undefined || this.imagen == null) {
        this.id = 0;
        this.profileImage = './assets/images/sinFoto.png';
      } else {
        this.id = this.imagen.id;
        if (this.imagen.foto != null ) {
          let objectURL = 'data:image/png;base64,' + this.imagen.foto;
          this.profileImage = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        } else {
          this.profileImage = './assets/images/sinFoto.png';
        }  
      }
      console.log(data);
    },
    error => {          
      console.log(error);
    });

    
  }

  onFileSelected(event){
    this.selectedFile = <File>event.target.files[0];
    if(this.selectedFile != null){
      var body = new FormData();
      body.append('image', this.selectedFile, this.personalRelacion.id.toString());
          
      var reader = new FileReader();
      reader.onload = (event: any) => {
          this.profileImage = event.target.result;
      }
      reader.readAsDataURL(this.selectedFile);

      this.personalService.UpdateProfileImage(body).subscribe(
        data => {
          console.log(data);
        },
        error => {
          console.log(error);
      });
    }
  }

  borrarPersonal() 
  {
    this.MensajeError = "";
    this.Invalido = false;

    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";
    
    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        this.personalService.BorrarDatosPersonales(this.SelectedId).subscribe(data => 
          {
            this.showDetails = false;
            this.profileImage = './assets/images/sinFoto.png';
            this.selectedEmp = null;
            this.retrievePersonal();
          },
          error => 
          {
            if (error.status == 400)
            {
              this.Invalido = true;

              this.MensajeError = this.erroresService.MostrarError400(error);
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
            }
            this.Invalido = true;
          });
      }      
    });

    
  }
}
  